import { CellRange as CellRange_internal } from "./CellRange";
/**
 * An indentifier for a specific cell in the grid.
*/
var IgrCellRange = /** @class */ /*@__PURE__*/ (function () {
    function IgrCellRange() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrCellRange.prototype.createImplementation = function () {
        return new CellRange_internal();
    };
    Object.defineProperty(IgrCellRange.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrCellRange.prototype.onImplementationCreated = function () {
    };
    IgrCellRange.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrCellRange.prototype, "startColumn", {
        /**
         * Gets or sets the start column of the range.
        */
        get: function () {
            return this.i.k;
        },
        set: function (v) {
            this.i.k = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrCellRange.prototype, "endColumn", {
        /**
         * Gets or sets the end column of the range.
        */
        get: function () {
            return this.i.i;
        },
        set: function (v) {
            this.i.i = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrCellRange.prototype, "startRow", {
        /**
         * Gets or sets the start row of the range.
        */
        get: function () {
            return this.i.l;
        },
        set: function (v) {
            this.i.l = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrCellRange.prototype, "endRow", {
        /**
         * Gets or sets the end row of the range.
        */
        get: function () {
            return this.i.j;
        },
        set: function (v) {
            this.i.j = +v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrCellRange;
}());
export { IgrCellRange };
//# sourceMappingURL=igr-cell-range.js.map
